import { FC, PropsWithChildren } from 'react';

import './index.scss';

const Title: FC<PropsWithChildren> = ({ children }) => {
  return <div className="legal-page__title headline--m">{children}</div>;
};

export default Title;
